import React, { useState } from "react"
import { Button, NavItem, NavLink, Nav } from "reactstrap"
import styles from "./PlayerTab.module.scss"
import { useSelector } from "react-redux"
import { getSportsConfig } from "../../../../utility/constants/sportConfig"

export default function PlayersTab({
	selectedPlayer,
	setSelectedPlayer,
	selectedEvent,
	setSelectedEvent,
	followupPlayer,
	setFollowupPlayer,
	followupEvent,
	setFollowupEvent,
	setActiveTab,
	quickEvents,
}) {
	const { hasBench } = getSportsConfig(localStorage.getItem("sport"))
	const { homeTeam, awayTeam } = useSelector((state) => state.players)
	const [shouldPinPlayers, setShouldPinPlayers] = useState(
		hasBench ? JSON.parse(localStorage.getItem("shouldPinPlayers")) : false
	)

	const removeFollowupData = () => {
		if (followupPlayer) {
			setFollowupPlayer({})
		} else if (followupEvent) {
			setFollowupEvent()
		}
	}

	const onPlayerSelect = (player, team) => {
		removeFollowupData()

		if (player.playerId == selectedPlayer.playerId) {
			setSelectedPlayer({})
			setSelectedEvent({})
		} else {
			setSelectedPlayer({ ...player, team })
			setSelectedEvent({})
			setActiveTab(2)
		}
	}

	const onQuickEventSelect = (event, player, team) => {
		removeFollowupData()

		if (selectedPlayer.playerId == player.playerId) {
			if (event.name == selectedEvent.name) {
				setSelectedPlayer({})
				setSelectedEvent({})
			} else {
				setSelectedEvent(event)
			}
		} else {
			setSelectedPlayer({ ...player, team })
			setSelectedEvent(event)
		}

		if (event.followup) setActiveTab(3)
	}

	const createPlayerButton = (player, team) => {
		const isSelectedPlayer = player.playerId == selectedPlayer.playerId

		return (
			<div key={`playerBtn${player.playerId}`} className={styles.playerBtn}>
				<div className={styles.top}>
					<div
						className={`${styles.playerTNum} ${
							isSelectedPlayer ? styles.active : ""
						}`}
					>
						{player.tshirtNumber}
					</div>
					<Button.Ripple
						color="primary"
						size="lg"
						outline={!isSelectedPlayer}
						onClick={() => onPlayerSelect(player, team)}
					>
						{`${player.name} ${player.surname}`}
					</Button.Ripple>
				</div>
				<div className={styles.bottom}>
					{quickEvents.map((event, index) => (
						<Button.Ripple
							key={`ev${player.playerId}-${index}`}
							color="primary"
							size="sm"
							outline={
								!(
									isSelectedPlayer &&
									event.name == selectedEvent.name
								)
							}
							onClick={() => onQuickEventSelect(event, player, team)}
						>
							{event.name}
						</Button.Ripple>
					))}
				</div>
			</div>
		)
	}

	const createPlayerButtons = (team) => {
		if (!team.players) return <></>

		if (!shouldPinPlayers) {
			return (
				<div>
					<h1 className={styles.teamName}>{team.name}</h1>
					<div className={styles.grid2}>
						{team.players.map((player) =>
							createPlayerButton(player, team.name)
						)}
					</div>
				</div>
			)
		}

		const pinnedPlayers = []
		const unpinnedPlayers = []
		team.players.forEach((player) => {
			if (player.pin) pinnedPlayers.push(player)
			else unpinnedPlayers.push(player)
		})

		return (
			<div>
				<h1 className={styles.teamName}>{team.name}</h1>
				<div className={styles.grid2}>
					{pinnedPlayers.map((player) =>
						createPlayerButton(player, team.name)
					)}
				</div>
				<div className={`${styles.grid2} ${styles.bottomGrid}`}>
					{unpinnedPlayers.map((player) =>
						createPlayerButton(player, team.name)
					)}
				</div>
			</div>
		)
	}

	return (
		<>
			{hasBench && (
				<Nav pills style={{ position: "absolute", top: 0, right: "3em" }}>
					<NavItem>
						<NavLink
							active={shouldPinPlayers}
							onClick={() => {
								localStorage.setItem("shouldPinPlayers", true)
								setShouldPinPlayers(true)
							}}
						>
							Pin
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							active={!shouldPinPlayers}
							onClick={() => {
								localStorage.setItem("shouldPinPlayers", false)
								setShouldPinPlayers(false)
							}}
						>
							Unpin
						</NavLink>
					</NavItem>
				</Nav>
			)}
			<div className={`${styles.grid2} ${styles.gridWrapper}`}>
				{createPlayerButtons(homeTeam)}
				{createPlayerButtons(awayTeam)}
			</div>
		</>
	)
}
